import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const ActionContext = React.createContext(undefined);

export function ActionContextProvider({ children, menuItemValue }) {
  // Maps an <Action>'s value prop to its selectedIf function (or the one created based on its to)
  const [selectedIfFns, setSelectedIfFns] = useState({});
  const { location } = useHistory();
  const selected = useMemo(() => {
    const shouldBeSelected = Object.entries(selectedIfFns)
      .filter(([_, selectedIf]) => {
        return selectedIf({ location });
      });

    if (shouldBeSelected.length === 0) {
      return undefined;
    }
    // Prefer for menu to be selected if menu and another page are selected - for example, if you're on the dashboard and tap menu, then both are selected, but only menu should appear selected
    if (shouldBeSelected.find(([value]) => value === menuItemValue)) return menuItemValue;
    const [value] = shouldBeSelected[0];
    return value;
  }, [selectedIfFns, location, menuItemValue]);

  return (
    <ActionContext.Provider value={{ selectedIfFns, setSelectedIfFns, selected }}>
      {children}
    </ActionContext.Provider>
  );
}

ActionContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  menuItemValue: PropTypes.string.isRequired,
};

export const useActionContext = () => {
  const context = useContext(ActionContext);
  if (!context) throw new Error('useActionContext must be called from ActionContextProvider');
  return context;
};
export const useCheckSelected = (value, selectedIf) => {
  const { selectedIfFns, setSelectedIfFns, selected } = useActionContext();
  if (!selectedIfFns[value] || selectedIfFns[value] !== selectedIf) setSelectedIfFns((existing) => ({ ...existing, [value]: selectedIf }));
  return selected === value;
};
